/**
 * Created by lihanying on 2017/6/29.
 */

export const GETCLUBTABLE = "GETCLUBTABLE"
export const GETCLUBTIMEPRICE = "GETCLUBTIMEPRICE"
export const GETCLUBTABLETYPE = "GETCLUBTABLETYPE"
export const GETTOTALTYPE = "GETTOTALTYPE"
export const GETCLUBTABLEINFO = "GETCLUBTABLEINFO"
export const GETWALLETTYPE = "GETWALLETTYPE"
export const GETQROCODE = "GETQROCODE"

export const GETALLPACKAGE = "GETALLPACKAGE"
export const GETALLOWPACKAGE = "GETALLOWPACKAGE"
export const GETEDITRECORD = "GETEDITRECORD"
export const ENABLE = 1
export const DISABLE = 0
export const IS_EXIST_RELATION_INFO = 1009



// WEBPACK FOOTER //
// ./src/containers/ClubTable/constants.js